.imageContainer {
  width: 75px;
  height: 75px;
  background-color: $gray-1250;
  display: grid;
  place-content: center;
}

.imageOverlay {
  width: 100%;
  height: 100%;
}
